
import Vue from "vue";
import YmapPlugin, {
  loadYmap
} from "vue-yandex-maps";

const settings = {
  apiKey: process.env.yandexApiKey,
  lang: "ru_RU",
  coordorder: "latlong",
  version: "2.1",
}
Vue.use(YmapPlugin, settings);

export default {
  name: "Map",

  data: function () {
    return {
      yandexMap: null
    }
  },

  props: {
    address: {
      type: String,
      default: ""
    }
  },

  mounted: async function () {
    await this.initYandexMap();
  },

  methods: {
    initYandexMap: async function () {
      if (!this.$refs["yandex-map"]) {
        return
      }

      // Загрузка данные яндекс карты
      await loadYmap({...settings, debug: true});
      this.yandexMap = new ymaps.Map(this.$refs["yandex-map"], {
        center: [57.649562, 82.957988],
        zoom: 12,
        behaviors: ['drag', 'dblClickZoom', 'multiTouch']
      });

      // Получение координат города
      const informationCity = await this._getInformationCity(this.address) || null;
      if (!informationCity) {
        return
      }

      const {
        coordinates
      } = informationCity;
      const yandexMap = this.yandexMap;
      const cluster = this._generateCluster();
      const placemark = this._generatePlacemark({
        coordinates: coordinates,
        label: this.address
      });
      cluster.add(placemark);
      yandexMap.geoObjects.add(cluster);
      yandexMap.setBounds(cluster.getBounds(), {});
      yandexMap.setZoom(14);
    },

    _getInformationCity: async function (city) {
      return await ymaps.geocode(city).then((res) => {
        const coordinates = res.geoObjects.get(0).geometry.getCoordinates();

        return {
          coordinates
        }
      }).catch(() => {
        return {
          coordinates: [],
        }
      });
    },

    _generateCluster: function () {
      const clusterIconLayout = ymaps.templateLayoutFactory.createClass('' +
        '<div class="route-map-with-points-map-pin-cluster">' +
        '<span>{{ properties.geoObjects.length }}</span>' +
        '</div>')

      return new ymaps.Clusterer({
        clusterDisableClickZoom: false,
        clusterNumbers: [50],
        clusterIconLayout: clusterIconLayout,
        clusterIconShape: {
          type: 'Rectangle',
          coordinates: [[0, 0], [46, 46]]
        }
      })
    },
    _generatePlacemark: function (point) {
      const iconContentLayout = ymaps.templateLayoutFactory.createClass(
        `<div class="route-map-with-points-map-map-poins"/>`
      );

      return new ymaps.Placemark(point.coordinates, {
        hintContent: point.city_name,
        balloonContent: point.label
      }, {
        balloonContent: point.label,
        iconImageSize: [30, 26],
        iconImageOffset: [-15, -30],
        iconLayout: "default#imageWithContent",
        iconImageHref: require('~/assets/img/svg/common/pin-black.svg')
      })
    },
  }
}
